var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_855_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4443 0C14.5257 0 0 14.5257 0 32.4443C0 50.3628 14.5257 64.8891 32.4443 64.8891C50.3628 64.8891 64.8891 50.3628 64.8891 32.4443C64.8689 14.5341 50.355 0.0201985 32.4443 0ZM32.4443 61.6443C16.3175 61.6443 3.24425 48.571 3.24425 32.4443C3.24425 16.3175 16.3175 3.24425 32.4443 3.24425C48.571 3.24425 61.6443 16.3175 61.6443 32.4443C61.6259 48.5633 48.5633 61.6259 32.4443 61.6443Z",
    fill: "#B69D74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6455 19.8679C27.9707 19.278 26.9459 19.3469 26.356 20.0212C25.7667 20.696 25.8356 21.7208 26.5098 22.3107L38.0919 32.4445L26.5093 42.5788C25.8344 43.1687 25.7661 44.1935 26.3554 44.8678C26.9453 45.5427 27.9701 45.6116 28.645 45.0217L41.6225 33.6659C41.9748 33.3582 42.1768 32.9126 42.1768 32.4445C42.1768 31.9763 41.9748 31.5314 41.6225 31.2231L28.6455 19.8679Z",
    fill: "#B69D74"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_855_236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.8889,
    height: 64.8889,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/Right Arrow.6f57605849fcf2790eeecb20d93a5fce.svg";
export { ForwardRef as ReactComponent };